/**
 * @author  Agence Dn'D <contact@dnd.fr>
 * @license https://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * @link    https://www.dnd.fr/
 */

class SlidingScale {
  constructor() {
    this.container = document.querySelector('.sliding-scale-container');
    this.contentElement = document.querySelector('[data-sliding-scale-content]');
    this.init();
  }

  init() {
    document.addEventListener('on:variant:change', (event) => {
      const variant = event.detail.variant;
      const slidingScale = window.variantsSlidingScaleData?.[variant.id];
      this.updateSlidingScaleDisplay(slidingScale);
    });
  }

  updateSlidingScaleDisplay = (slidingScale) => {
    if (!this.container || !this.contentElement) return;

    if (slidingScale && String(slidingScale).trim() !== '') {
      this.contentElement.innerHTML = slidingScale;
      this.container.style.display = '';
    } else {
      this.container.style.display = 'none';
    }
  }
}

new SlidingScale();